// @flow
export { default } from './CategoryEditModal';



// WEBPACK FOOTER //
// ./src/components/write/CategoryEditModal/index.js